/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskUpdateRequest } from './taskUpdateRequest';

export type GenerateTaskObjectivesStreamBody = TaskUpdateRequest | null;
